import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../components/common/Card";
import { addFuelPurchase, GetFuelDetails } from "../../services/FuelService";
import { toast } from "react-toastify";

const fuelTypes = ["Diesel", "Petrol", "Electric"];

const StaffManagement2 = () => {
  const [fuelList, setFuelList] = useState([]);
  // const  []
  const formik = useFormik({
    initialValues: {
      vendorName: "",
      vehicleName: "",
      vehicleNumber: "",
      hourReading: "",
      fuelRate: "",
      fuelQuantity: "",
      totalAmount: "",
      fuelType: "",
    },
    onSubmit: async (values) => {
      // console.log("Form Submitted", values);

      let formdata = {
        vendorName: values.vendorName,
        quantity: values.fuelQuantity,
        rate: values.fuelRate,
        fuelType: values.fuelType,
        totalAmount: values["totalAmount"],
      };

      await addFuelPurchase(formdata)
        .then((res) => {
          if (res && res.data.statusDescription.statusCode == 200) {
            toast.success(res.data.statusDescription.description);
            let e;

            formik.handleReset(e);
          } else {
            toast.warn(res.data.statusDescription.description);
          }
        })
        .catch((err) => {});
    },
  });

  useEffect(() => {
    if (formik.values.fuelRate && formik.values.fuelQuantity) {
      let value = formik.values.fuelRate * formik.values.fuelQuantity;
      formik.setFieldValue("totalAmount", value);
    }
  }, [formik.values.fuelRate, formik.values.fuelQuantity]);

  useEffect(() => {
    getFuelDetails();
  }, []);

  const getFuelDetails = async (list) => {
    await GetFuelDetails().then((res) => {
      if (res && res?.data?.statusDescription?.statusCode == 200) {
        // // console.log(res.data);
        setFuelList(res.data.fuelTypeList);
      }
    });
  };

  return (
    <Card title={"Add fuel stock"}>
      <Box className="container mt-4">
        <form onSubmit={formik.handleSubmit} className="mt-4">
          <div className="row mb-2">
            <div className="col-md-4 col-12  mb-2">
              <TextField
                fullWidth
                label="Vendor Name"
                name="vendorName"
                size="small"
                value={formik.values.vendorName}
                required
                onChange={formik.handleChange}
                error={
                  formik.touched.vendorName && Boolean(formik.errors.vendorName)
                }
                helperText={
                  formik.touched.vendorName && formik.errors.vendorName
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Vehicle Name"
                name="vehicleName"
                size="small"
                required
                value={formik.values.vehicleName}
                onChange={formik.handleChange}
                error={
                  formik.touched.vehicleName &&
                  Boolean(formik.errors.vehicleName)
                }
                helperText={
                  formik.touched.vehicleName && formik.errors.vehicleName
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Vehicle Number"
                name="vehicleNumber"
                size="small"
                value={formik.values.vehicleNumber}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.vehicleNumber &&
                  Boolean(formik.errors.vehicleNumber)
                }
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
          </div>

          <div className="row mb-2">
            {/* <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Hour Reading"
                name="hourReading"
                size="small"
                required
                value={formik.values.hourReading}
                onChange={formik.handleChange}
                error={
                  formik.touched.hourReading &&
                  Boolean(formik.errors.hourReading)
                }
                helperText={
                  formik.touched.hourReading && formik.errors.hourReading
                }
              />
            </div> */}
            <div className="col-md-4 col-12 mb-2">
              <FormControl fullWidth size="small">
                <InputLabel>Fuel Type</InputLabel>
                <Select
                  name="fuelType"
                  value={formik.values.fuelType}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.fuelType && Boolean(formik.errors.fuelType)
                  }
                >
                  {fuelList?.map((x) => (
                    <MenuItem key={x.fuelType} value={x.fuelType}>
                      {x.fuelType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                size="small"
                label="Fuel Rate"
                name="fuelRate"
                required
                value={formik.values.fuelRate}
                onChange={formik.handleChange}
                error={
                  formik.touched.fuelRate && Boolean(formik.errors.fuelRate)
                }
                helperText={formik.touched.fuelRate && formik.errors.fuelRate}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Quantity"
                name="fuelQuantity"
                size="small"
                required
                value={formik.values.fuelQuantity}
                onChange={formik.handleChange}
                error={
                  formik.touched.fuelQuantity &&
                  Boolean(formik.errors.fuelQuantity)
                }
                helperText={
                  formik.touched.fuelQuantity && formik.errors.fuelQuantity
                }
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Total Amount"
                name="totalAmount"
                size="small"
                disabled={true}
                required
                value={formik.values.totalAmount}
                onChange={formik.handleChange}
                error={
                  formik.touched.totalAmount &&
                  Boolean(formik.errors.totalAmount)
                }
                helperText={
                  formik.touched.totalAmount && formik.errors.totalAmount
                }
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-end d-flex justify-content-end">
              <Button
                type="reset"
                onClick={(e) => {
                  formik.handleReset(e);
                }}
                variant="contained"
                className="clr_btn me-3"
                color="secondary"
              >
                Clear
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="yellow_btn_1"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Card>
  );
};

export default StaffManagement2;
